import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Button } from '@winelidays/wld-tsx-2/elements';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
import { forwardRef } from 'react';
const LimitedTextContent = (t0, ref) => {
    const $ = _c(16);
    const { isReady, noSeeMoreButton, seeMore, text, hasMore, btnClassName, toggleSeeMore } = t0;
    const translate = useTranslate();
    let t1;
    if ($[0] !== btnClassName || $[1] !== hasMore || $[2] !== noSeeMoreButton || $[3] !== toggleSeeMore || $[4] !== translate) {
        t1 = noSeeMoreButton || !hasMore ? null : <Button className={btnClassName} onClick={toggleSeeMore} title={capitalize(translate("messages.see_more"))}>{capitalize(translate("messages.see_more"))}</Button>;
        $[0] = btnClassName;
        $[1] = hasMore;
        $[2] = noSeeMoreButton;
        $[3] = toggleSeeMore;
        $[4] = translate;
        $[5] = t1;
    }
    else {
        t1 = $[5];
    }
    const btnContent = t1;
    const ellipsisClassName = btnContent ? "mr-2" : "";
    const t2 = `inline-block w-full whitespace-pre-wrap ${hasMore && isReady && !seeMore ? "" : "absolute left-0 top-0 invisible"}`;
    let t3;
    if ($[6] !== text) {
        t3 = <span>{text}</span>;
        $[6] = text;
        $[7] = t3;
    }
    else {
        t3 = $[7];
    }
    let t4;
    if ($[8] !== ellipsisClassName) {
        t4 = <span className={ellipsisClassName}>...</span>;
        $[8] = ellipsisClassName;
        $[9] = t4;
    }
    else {
        t4 = $[9];
    }
    let t5;
    if ($[10] !== btnContent || $[11] !== ref || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
        t5 = <span ref={ref} data-limited-text-span={true} className={t2}>{t3}{t4}{btnContent}</span>;
        $[10] = btnContent;
        $[11] = ref;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
    }
    else {
        t5 = $[15];
    }
    return t5;
};
export default forwardRef(LimitedTextContent);
